import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/css/login.scss';
import LoginService from '../../services/LoginService';

class AccDeletion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      loadingCode: false,
      error: ''
    };
  }
  async onInputchange(event) {
    if (this.state.error || this.state.success) {
      await this.setState({ error: '', success: '' });
    }
    const name = event.target.name;
    this.setState({
      [name]: event.target.value
    });
  }

  async send() {
    if (this.state.reason === '') {
      return;
    }
    await this.setState({ loadingCode: true });
    const { reason } = this.state;
    let tokenData = await LoginService.getToken();
    let msg =
      'Your account deletion request has been received. Your account will be purged within the next 48 hours.';
    try {
      await LoginService.sendMail({ reason, user_id: tokenData.userId }, tokenData);
      await this.setState({ loadingCode: false, success: msg, error: '' });
    } catch (e) {
      await this.setState({ loadingCode: false, error: e.message, success: '' });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
          className="modal sub-modal-a"
        >
          <div className="modal-header no-border">
            <h5 className="modal-title">&nbsp;</h5>
          </div>
          <ModalBody className="background-skin overflow-hidden main-bg">
            <div className="card flex-md-row box-shadow h-100 p-3 no- main-bg">
              <div className="row row-width">
                <div className="col-lg-12 order-types " id="order_type_id">
                  <div className="ps-3 pe-3" id="order_time">
                    <div className="time-field mb-3">
                      <div className="f1 text-center">
                        <span className="ps-2">
                          Are you sure you want to delete your account?
                        </span>
                        <p className="f3">We are sorry to see you go:(</p>
                        <p className="f3">Please let us know why you have chosen to delete your account.</p>

                        <div className="col-lg-12 order-types mt-4" id="order_type_id">
                          <form>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                id="reason"
                                name="reason"
                                placeholder="Reason"
                                value={this.state.reason}
                                onChange={this.onInputchange.bind(this)}
                                required
                              />
                              {!this.state.reason && (
                                <small className="text-danger">Please enter your reason.</small>
                              )}
                              {this.state.error !== '' && (
                                <small className="text-danger">{this.state.error}</small>
                              )}
                              {this.state.success !== '' && (
                                <p>
                                  <small className="f4 text-success">{this.state.success}</small>
                                </p>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                      <br></br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="no-border">
            <div className="container-fluid">
              <div className="row">
                <Button
                  className="col-lg-12 btn btn-primary btn-lg "
                  onClick={this.send.bind(this)}
                >
                  Submit
                  {this.state.loadingCode && (
                    <div className="text-sm spinner-border primary-font-color ms-2" role="status">
                      <span className="sr-only"></span>
                    </div>
                  )}
                </Button>
                <Button
                  className="col-lg-12 btn btn-primary btn-lg bg-light no-border text-dark mt-2"
                  onClick={this.props.toggleModal}
                >
                  Close
                </Button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default AccDeletion;
